// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/radio/index.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Primary } from './Primary.story';
import { Disabled } from './Disabled.story';
import { Controlled } from './Controlled.story';
import { Uncontrolled } from './Uncontrolled.story';
import { Invalid } from './Invalid.story';
const basic = {
  rendered: <Primary />,
  source: `<Radio label="This is a Radio." />`
};
const controlled = {
  rendered: <Controlled />,
  source: `const [checked, setChecked] = React.useState<'radio1' | 'radio2'>('radio1');

return (
  <Box
    css={{
      layout: 'column',
    }}
  >
    <Radio
      onClick={() => {
        setChecked('radio1');
      }}
      checked={checked === 'radio1'}
      label="You could go with this"
    />
    <Radio
      onClick={() => {
        setChecked('radio2');
      }}
      checked={checked === 'radio2'}
      label="Or you could go with that"
    />
  </Box>
);`
};
const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<Box
  css={{
    layout: 'column',
  }}
>
  <Radio name="group" label="Have some of Column A" />
  <Radio name="group" label="Try all of Column B" />
</Box>`
};
const invalid = {
  rendered: <Invalid />,
  source: `<Radio label="This is an invalid input" invalid />`
};
const disabled = {
  rendered: <Disabled />,
  source: `<Box
  css={{
    layout: 'column',
  }}
>
  <Radio name="group" label="Ah ah ah" disabled />
  <Radio
    name="group"
    disabled
    checked
    label="You didn't say the magic word"
  />
</Box>`
};
export const RadioExamples = {
  basic,
  controlled,
  uncontrolled,
  invalid,
  disabled
};